import React from "react";
import { useQuery } from "@apollo/client/react";
import LinearProgress from "@mui/material/LinearProgress";

import { ASSET_QUERY } from "../../../../constants/graphql/queries";
import { ProjectProvider } from "../../../../contexts/project";
import AssetModal from "../../../../views/inventory/requests/asset-details/AssetModal";
import { ProjectInventoryProvider } from "../../../../contexts/projectInventory";

export default function LocationAssetDetailsModal({ assetId, onClose, onSaved, variant = "narrow" }) {
  const { data: { asset } = {}, loading } = useQuery(ASSET_QUERY, {
    skip: !assetId,
    variables: { id: assetId },
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
  });

  if (!assetId) {
    return null;
  }

  if (loading) {
    return <LinearProgress sx={{ height: "1px" }} />;
  }

  if (!asset?.project?.id) {
    return null;
  }

  return (
    <ProjectInventoryProvider>
      <ProjectProvider id={asset.project.id} loadingComponent={<span />}>
        <AssetModal
          id={asset.id}
          reFetch={onSaved}
          onClose={onClose}
          open
          hideAddNew
          autoCloseOnSave
          onAfterSave={onSaved}
          variant={variant}
          showOnlySave
        />
      </ProjectProvider>
    </ProjectInventoryProvider>
  );
}
